import { gql } from '@apollo/client';

export interface DriverAddressOutput {
    streetAddress: string | null;
    unit: string | null;
    city: string | null;
    state: string | null;
    zipCode: string | null;
    county: string | null;
    latitude: number | null;
    longitude: number | null;
}

export interface RoutePlanningOrderOutput {
    orderId: number | null;
    stopNumber: number | null;
    latitude: number | null;
    longitude: number | null;
}

export interface DspTaskDetailWithChildrenOutput {
    id: number | null;
    parentId: number | null;
    taskName: string | null;
    workIndex: string | null;
    taskDate: string | null;
    status: number | null;
    isSplit: boolean | null;
    assignType: number | null;
    assignTypeDetail: string[] | null;
    totalParcels: number | null;
    assignedParcelCount: number | null;
    unassignedParcelCount: number | null;
    parcelNumberStart: number | null;
    parcelNumberEnd: number | null;
    driverId: number | null;
    driverName: string | null;
    startAddress: DriverAddressOutput | null;
    endAddress: DriverAddressOutput | null;
    routePlanningOrderList: RoutePlanningOrderOutput[];
    childTaskList: DspTaskDetailWithChildrenOutput[];
}

export interface GetDspTaskDetailWithChildrenResponse {
    getDspTaskDetailWithChildren: DspTaskDetailWithChildrenOutput | null;
}

export interface GetDspTaskDetailWithChildrenVariables {
    request: {
        warehouseId: number;
        dspTaskId: number;
        dspId?: number | null;
    };
}

export const GET_DSP_TASK_DETAIL_WITH_CHILDREN_FOR_DSP = gql`
    query GetDspTaskDetailWithChildrenForDsp($request: GetDspTaskDetailWithChildrenRequestInput!) {
        getDspTaskDetailWithChildrenForDsp(request: $request) {
            id
            parentId
            taskName
            taskDate
            status
            isSplit
            assignType
            assignTypeDetail
            totalParcels
            assignedParcelCount
            unassignedParcelCount
            parcelNumberStart
            parcelNumberEnd
            driverId
            driverName
            startAddress {
                streetAddress
                unit
                city
                state
                zipCode
                county
                latitude
                longitude
            }
            endAddress {
                streetAddress
                unit
                city
                state
                zipCode
                county
                latitude
                longitude
            }
            routePlanningOrderList {
                orderId
                stopNumber
                latitude
                longitude
            }
            childTaskList {
                id
                parentId
                taskName
                assignType
                assignTypeDetail
                totalParcels
                parcelNumberStart
                parcelNumberEnd
                driverId
                driverName
                startAddress {
                    streetAddress
                    unit
                    city
                    state
                    zipCode
                    county
                    latitude
                    longitude
                }
                endAddress {
                    streetAddress
                    unit
                    city
                    state
                    zipCode
                    county
                    latitude
                    longitude
                }
                routePlanningOrderList {
                    orderId
                    stopNumber
                    latitude
                    longitude
                }
            }
        }
    }
`;

export const GET_DSP_TASK_DETAIL_WITH_CHILDREN = gql`
    query GetDspTaskDetailWithChildren($request: GetDspTaskDetailWithChildrenRequestInput!) {
        getDspTaskDetailWithChildren(request: $request) {
            id
            parentId
            taskName
            workIndex
            taskDate
            status
            isSplit
            assignType
            assignTypeDetail
            totalParcels
            assignedParcelCount
            unassignedParcelCount
            parcelNumberStart
            parcelNumberEnd
            driverId
            driverName
            startAddress {
                streetAddress
                unit
                city
                state
                zipCode
                county
                latitude
                longitude
            }
            endAddress {
                streetAddress
                unit
                city
                state
                zipCode
                county
                latitude
                longitude
            }
            routePlanningOrderList {
                orderId
                stopNumber
                latitude
                longitude
            }
            childTaskList {
                id
                parentId
                taskName
                workIndex
                assignType
                assignTypeDetail
                totalParcels
                parcelNumberStart
                parcelNumberEnd
                driverId
                driverName
                startAddress {
                    streetAddress
                    unit
                    city
                    state
                    zipCode
                    county
                    latitude
                    longitude
                }
                endAddress {
                    streetAddress
                    unit
                    city
                    state
                    zipCode
                    county
                    latitude
                    longitude
                }
                routePlanningOrderList {
                    orderId
                    stopNumber
                    latitude
                    longitude
                }
            }
        }
    }
`;
